import Player from '@/data/Player';

export default class PlayerMapper {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public static mapFromObject(playersObj: Array<any>): Player {
    
    for(const playerObj of playersObj) {
      if(playerObj.id !== undefined) {
        return new Player(playerObj.id, playerObj.name, playerObj.active);
      }
    }
    
    throw new Error(`Can not find a player in object ${playersObj}.`);
  }
}